import React from 'react';
import { createNewFaq } from '../../../../Apis/FAQsApi';
import Form from './Form';


export default function AddFaq() {
    const onSubmit = async (e, data) => {
        e.preventDefault();
        //to send request
        return await createNewFaq(data).then(res => {
            console.log(res.data.data);
            return "done";          
        }).catch(err =>{
            console.log(err.response);
            return err.response.data.errors;
        })
    };

    return (
        <Form onSubmit={onSubmit}/>
    )
}
